import { useState } from 'react';
import { useSelector } from 'react-redux';
import { updateRendicionFondos } from '../../helpers/api_helper';

const useUpdateRendicionFondos = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    const updateRendicion = async (tipfol, numfol, data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await updateRendicionFondos(tipfol, numfol, {
                ...data,
                tenantId
            });
            console.log('Response from update rendicion fondos:', response);
            return { success: true, data: response };
        } catch (err) {
            const errorMessage = `Failed to update rendicion fondos: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { updateRendicion, loading, error };
};

export default useUpdateRendicionFondos;